import type {ThemeConfig} from 'antd';
import {theme} from "antd";

import DesignConfig from "@/theme/design.config";
import {hexToRgb} from "@/base/theme/design.base";

export type ThemeCallback = (mode: string) => ThemeConfig;
const getTheme: ThemeCallback = (mode = 'light') => {
	const currentDesignConfig = DesignConfig.hasOwnProperty(mode) ? DesignConfig[mode] : DesignConfig['light'];

	return {
		algorithm: theme.defaultAlgorithm,
		token: {
			fontSize: currentDesignConfig.fontSize.base,

			colorPrimary: currentDesignConfig.primaryColor,
			controlHeightLG: 50,

			controlHeight: 40,

			colorText: currentDesignConfig.textColor,

			colorBgContainer: currentDesignConfig.mainBgColor,
			colorBgElevated: currentDesignConfig.baseBgColor,
			colorFillTertiary: currentDesignConfig.primaryTint['50'],

			colorBorder: currentDesignConfig.borderColor,

			colorSplit: currentDesignConfig.borderColor,

			colorTextPlaceholder: currentDesignConfig.borderColor,
			// borderRadius: 2
		},
		components: {
			Progress: {
				remainingColor: `${currentDesignConfig.borderColor}30`,
			},
			Card: {
				headerBg: currentDesignConfig.primaryTint['50'],
				colorTextHeading: currentDesignConfig.secondaryColor,
			},
			Table: {
				headerBg: currentDesignConfig.primaryTint['50'],
				borderColor: currentDesignConfig.borderColor,
				colorSplit: currentDesignConfig.borderColor,
				headerSplitColor: currentDesignConfig.borderColor,
			},
			Switch: {
				handleSize: 18,
				trackHeight: 22,
				handleSizeSM: 14,
				trackHeightSM: 18,
			},
			Modal: {
				contentBg: currentDesignConfig.mainBgColor,
				headerBg: 'transparent'
			},
			Radio: {
				colorBorder: currentDesignConfig.primaryColor,
				lineWidth: 2,
			},
			Form: {},
			Input: {
				activeBg: currentDesignConfig.primaryTint['100'],
				colorBgContainer: `${currentDesignConfig.bgDefaultButton} !important`,
				activeBorderColor: currentDesignConfig.primaryTint['800'],
				controlOutline: 'none'
			},
			DatePicker: {
				activeBorderColor: currentDesignConfig.primaryTint['800'],
				controlOutline: 'none',
			},
			Slider: {
				trackBg: currentDesignConfig.primaryColor,
				handleColor: currentDesignConfig.primaryColor,
				railBg: currentDesignConfig.primaryTint['200'],
				trackHoverBg: currentDesignConfig.primaryColor,
				handleActiveColor: currentDesignConfig.primaryColor,
				railSize: 7,
			},
			Button: {
				primaryShadow: `0px 7px 26px -3px rgba(${hexToRgb(currentDesignConfig.primaryColor).join(',')},0.75)`,
				fontWeight: 500,
				controlHeight: 40,
				controlHeightSM: 32,
				controlOutline: 'none',
				defaultBg: currentDesignConfig.bgDefaultButton,
				defaultBorderColor: 'transpareent',
				defaultShadow: `0px 5px 12px -4px rgba(0, 0, 0,0.10)`,
				borderRadius: 10,
				borderRadiusSM: 8,
				lineWidth: 2,
			},
			Menu: {
				itemHeight: 60,
				iconMarginInlineEnd: 18,
				itemActiveBg: currentDesignConfig.bgDefaultButton,
				itemSelectedBg: currentDesignConfig.bgDefaultButton,
				itemSelectedColor: 'none',
				itemBg: 'transparent',
			},
			Dropdown: {
				controlItemBgActive: `${currentDesignConfig.primaryTint['200']} !important`,
				controlItemBgHover: currentDesignConfig.primaryTint['100'],
			},
			Select: {
				optionActiveBg: currentDesignConfig.primaryTint['100'],
				selectorBg: `${currentDesignConfig.bgDefaultButton} !important`,
				controlItemBgActive: `${currentDesignConfig.primaryTint['200']}`,
				colorTextPlaceholder: currentDesignConfig.textColor,
				colorTextQuaternary: currentDesignConfig.textColor,
			},
			Layout: {
				colorBgbase: 'transparent',
				bodyBg: 'transparent',
			}
		},
	}
};

export default getTheme;